import React, { useState, useEffect } from 'react'
import { restoreUserApi, suspendUserApi } from '../api/usersApi';

const MultipleSuspendPopup = ({ isOpen, title, description, ref, status, handleActionUser, reason, setReason, errorMessage, setErrorMessage, onClose, isSuspendLoading }) => {
    const [changedReason, setChangedReason] = useState('')

    useEffect(() => {
        if (isOpen) {
            setChangedReason(reason || '');
        }
    }, [isOpen, reason])
    if (!isOpen) return null;
    return (
        <div className="popup-overlay">
            <div className="popup-box" ref={ref}>
                <div className='popup-top-content'>
                    <div className="popup-close" onClick={() => { onClose(); }}>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 1L1 13M1 1L13 13" stroke="#05171A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <div className='popup-content'>
                        <div className='popup-title'>{title}</div>
                        <p className="description">
                            {description}
                        </p>
                        <p className="warning">
                            This action is irreversible, so please confirm if you're sure.
                        </p>
                    </div>
                    <div className={`input-group ${changedReason ? 'filled' : ''} ${errorMessage && 'show-error'}`}>
                        <input type="text" id='reason' className='' name='reason' autoComplete="off" value={changedReason} onChange={(e) => {
                            setChangedReason(e.target.value);
                            if (errorMessage) setErrorMessage('');
                        }} />
                        <label htmlFor="reason">
                            {status === "suspended" ? "Reason to restore" : "Reason to suspension"}
                        </label>
                    </div>
                    {errorMessage && <p className="error-message">{errorMessage}</p>}
                </div>
                <div className="button-row">
                    <button className="cancel-btn" onClick={() => { onClose(); }}>Cancel</button>
                    <button
                        className={`suspend-btn ${status === "suspended" ? "restore-btn" : ""}`}
                        onClick={() => handleActionUser(changedReason)}>
                        {
                            isSuspendLoading ?
                                <div className="registerLoader">
                                    <div className="ring-loader"></div>
                                </div> :
                                <>
                                    {status === "suspended" ?
                                        'Restore' : 'Suspend'
                                    }
                                </>
                        }
                    </button>
                </div>
            </div>
        </div>
    )
}

export default MultipleSuspendPopup